import React, { Fragment, useState, useEffect } from 'react';
import { Row, Col, Input, Button } from 'reactstrap';
import { Search } from 'react-feather';
import DatePicker from 'react-datepicker';
import { useSelector, useDispatch } from 'react-redux';
import { setFilters, resetFilters } from 'Services/Features/Order/orderSlice';
import { getAllOrder, exportOrders, addOrder } from 'Services/Features/Order/Utils/orderUtils';
import Select from 'react-select';
import SelectBranch from '../Filter/SelectBranch';
import AddOrderOfflineForm from '../Form/AddOrderOfflineForm';
import { GetAdminRole } from 'Component/Common/GetAdminRole';
import FormModal from 'Component/Common/Form/FormModal';
import { resetSetupOrder } from 'Services/Features/Order/orderSlice';
import { toast } from 'react-toastify';

const FindOrder = () => {
    const dispatch = useDispatch()
    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, endDate] = dateRange;
    const filters = useSelector(state => state.order.filters)
    const [selectedStatusValue, setSelectedStatusValue] = useState(null)
    const [selectedTypeValue, setSelectedTypeValue] = useState(null)
    const [searchUserValue, setSearchUserValue] = useState('')
    const user = JSON.parse(localStorage.getItem('USER'));
    const role = GetAdminRole(user);
    const [modalOrder, setModalOrder] = useState(false);
    const dataSetupOrder = useSelector(state => state.order.setupOrder);
    
    const toggleModalOrder = () => {
        dispatch(resetSetupOrder());
        setModalOrder(!modalOrder);
    };

    // useEffect untuk sinkronisasi state local dengan Redux filters
    useEffect(() => {
        // Sinkronisasi filter type
        const typeFilter = filters['filter[type]'];
        if (!typeFilter) {
            setSelectedTypeValue(null);
        } else {
            const typeOption = optionsType.find(option => option.value === typeFilter);
            setSelectedTypeValue(typeOption || null);
        }

        // Sinkronisasi filter status
        const statusFilter = filters['filter[status]'];
        if (!statusFilter) {
            setSelectedStatusValue(null);
        } else {
            const statusOption = optionsStatus.find(option => option.value === statusFilter);
            setSelectedStatusValue(statusOption || null);
        }

        // Sinkronisasi filter date range
        const startDateFilter = filters['filter[start_date]'];
        const endDateFilter = filters['filter[end_date]'];
        if (!startDateFilter && !endDateFilter) {
            setDateRange([null, null]);
        } else {
            const startDate = startDateFilter ? new Date(startDateFilter) : null;
            const endDate = endDateFilter ? new Date(endDateFilter) : null;
            setDateRange([startDate, endDate]);
        }

        // Sinkronisasi filter user name
        const userNameFilter = filters['filter[user.name]'];
        setSearchUserValue(userNameFilter || '');
    }, [filters['filter[type]'], filters['filter[status]'], filters['filter[start_date]'], filters['filter[end_date]'], filters['filter[user.name]']]);

    // type ['onlinie', 'offline']
    const optionsType = [
        { value: 'online', label: 'Online' },
        { value: 'offline', label: 'Offline' },
    ];
    // status ['pending', 'paid', 'canceled', 'completed']
    const optionsStatus = [
        { value: 'pending', label: 'Pending' },
        { value: 'paid', label: 'Paid' },
        { value: 'on_process', label: 'On Process' },
        { value: 'canceled', label: 'Canceled' },
        { value: 'completed', label: 'Completed' },
    ];

    const handleSelectChangeType = (selectedOption) => {
        setSelectedTypeValue(selectedOption);
        dispatch(setFilters({
            ...filters,
            'page': 1,
            'filter[type]': selectedOption ? selectedOption.value : ''
        }));
        dispatch(getAllOrder({
            ...filters,
            'page': 1,
            'filter[type]': selectedOption ? selectedOption.value : ''
        }));
    }

    const handleSelectChangeStatus = (selectedOption) => {
        setSelectedStatusValue(selectedOption);
        dispatch(setFilters({
            ...filters,
            'page': 1,
            'filter[status]': selectedOption ? selectedOption.value : ''
        }));
        dispatch(getAllOrder({
            ...filters,
            'page': 1,
            'filter[status]': selectedOption ? selectedOption.value : ''
        }));
    }

    const handleDateChange = (update) => {
        setDateRange(update);
        const [start, end] = update;
        const formatDate = (date) =>
            date
                ? date.getFullYear() +
                '-' +
                String(date.getMonth() + 1).padStart(2, '0') +
                '-' +
                String(date.getDate()).padStart(2, '0')
                : '';
        const newFilters = {
            ...filters,
            'page': 1,
            'filter[start_date]': formatDate(start),
            'filter[end_date]': formatDate(end),
        };
        dispatch(setFilters(newFilters));
    };

    const handleClickSearch = (e) => {
        e.preventDefault()

        const [start, end] = dateRange;
        const formatDate = (date) =>
            date
                ? date.getFullYear() +
                '-' +
                String(date.getMonth() + 1).padStart(2, '0') +
                '-' +
                String(date.getDate()).padStart(2, '0')
                : '';

        // Kalau cuma pilih satu tanggal, anggap itu start & end
        const finalStart = start;
        const finalEnd = end || start;

        const newFilters = {
            ...filters,
            'filter[start_date]': formatDate(finalStart),
            'filter[end_date]': formatDate(finalEnd),
            'page': 1,
            'is_export': ''
        };

        dispatch(setFilters(newFilters));
        dispatch(getAllOrder(newFilters));
    }


    const handleClickExport = (e) => {
        e.preventDefault()
        dispatch(exportOrders(filters));
    }

    const handleResetFilter = (e) => {
        e.preventDefault();
        const user = JSON.parse(localStorage.getItem('USER'));
        const role = GetAdminRole(user);

        const resetData = role === 'admin'
            ? { 'filter[branch_id]': user?.branch_id || '' }
            : {};
        setDateRange([null, null]);
        setSelectedStatusValue(null);
        setSelectedTypeValue(null);
        setSearchUserValue('');
        dispatch(resetFilters());
        dispatch(setFilters(resetData));
        dispatch(getAllOrder(resetData));
    }

    const handleDiscardOrder = () => {
        dispatch(resetSetupOrder());
        setModalOrder(false);
    }

    const validationDataSetupOrder = () => {
        // Validasi dataSetupOrder sebelum mengirim
        // Pastikan semua field yang diperlukan sudah diisi
        if (!dataSetupOrder.user_id || !dataSetupOrder.branch_id || !dataSetupOrder.schedule_hour_start ||
            !dataSetupOrder.schedule_hour_end || !dataSetupOrder.schedule_date) {
            return false; // Atau tampilkan pesan error
        }
        return true;
    }

    const handleSubmitOrder = () => {
        const successCallback = () => {
            setModalOrder(false); // Tutup modal hanya jika sukses
        };
        if (!validationDataSetupOrder()) {
            toast.error('Mohon lengkapi form wajib yang mencakup cabang, pengguna, tanggal, jam mulai, dan jam selesai.', {
                autoClose: 4000 
            });            
            return;
        }

        dispatch(addOrder({
            ...dataSetupOrder,
            successCallback
        }));
    }


    return (
        <Fragment>
            <FormModal
                isOpen={modalOrder}
                toggle={toggleModalOrder}
                title={`Tambah Reservasi Offline`}
                handleSubmit={handleSubmitOrder}
                handleDiscard={handleDiscardOrder}
            >
                <AddOrderOfflineForm />
            </FormModal>
            <Col xl="12">
                <div className="job-filter">
                    <div className="faq-form">
                        <Col className="d-flex justify-content-center align-items-center px-0" xs="12" sm="12" md="12" lg="12" xl="12">
                            <Row className="justify-content-between align-items-center">
                                <Col className="d-flex justify-content-between align-items-center mb-2" xs="12" sm="12" md="4" lg="4" xl="2" style={{ whiteSpace: 'nowrap' }}>
                                    <div className="position-relative w-100">
                                        <Input className="form-control" type="text" placeholder="Cari pelanggan.."
                                            value={searchUserValue}
                                            onKeyUp={(e) => e.key === 'Enter' ? handleClickSearch(e) : null}
                                            onChange={(e) => {
                                                setSearchUserValue(e.target.value);
                                                dispatch(setFilters({
                                                    ...filters,
                                                    'filter[user.name]': e.target.value
                                                }));
                                            }}
                                        />
                                        <Search className="search-icon position-absolute" style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }} />
                                    </div>
                                </Col>
                                <Col className="d-flex justify-content-between align-items-center mb-2" xs="12" sm="12" md="5" lg="5" xl="3">
                                    <DatePicker
                                        className="form-control digits datepicker"
                                        placeholderText="Pilih Rentang Waktu"
                                        selectsRange={true}
                                        icon={"fa fa-calendar-o"}
                                        toggleCalendarOnIconClick={true}
                                        showIcon={true}
                                        dateFormat="dd/MM/yyyy"
                                        startDate={filters['filter[start_date]'] ? new Date(filters['filter[start_date]']) : startDate}
                                        endDate={filters['filter[end_date]'] ? new Date(filters['filter[end_date]']) : endDate}
                                        onChange={(update) => {
                                            handleDateChange(update);
                                        }}
                                        // monthsShown={2}
                                        isClearable={true} />
                                </Col>
                                {(role === 'super_admin' || role === 'cs') && (
                                <Col className="mb-2" xs="12" sm="12" md="4" lg="4" xl="3" style={{ whiteSpace: 'nowrap' }}>
                                    <SelectBranch />
                                </Col>
                                )}
                                <Col className="mb-2" xs="12" sm="12" md="4" lg="4" xl="2" style={{ whiteSpace: 'nowrap' }}>
                                    <Select
                                        options={optionsType}
                                        className="js-example-basic-single"
                                        isMulti={false}
                                        isClearable={true}
                                        placeholder="Tipe Reservasi"
                                        onChange={handleSelectChangeType}
                                        value={selectedTypeValue}
                                    />
                                </Col>
                                <Col className="mb-2" xs="12" sm="12" md="4" lg="4" xl="2" style={{ whiteSpace: 'nowrap' }}>
                                    <Select
                                        options={optionsStatus}
                                        className="js-example-basic-single"
                                        isMulti={false}
                                        isClearable={true}
                                        placeholder="Status Reservasi"
                                        onChange={handleSelectChangeStatus}
                                        value={selectedStatusValue}
                                    />
                                </Col>
                                <Col
                                    className="d-flex flex-wrap justify-content-end align-items-center gap-2 mt-1"
                                    xs="12"
                                    style={{ whiteSpace: 'normal' }}
                                >
                                    <Button color="primary" onClick={handleClickSearch}>
                                        <i className="fa fa-search"></i> Cari
                                    </Button>
                                    <Button color="warning" onClick={handleResetFilter}>
                                        <i className="fa fa-refresh"></i> Reset
                                    </Button>
                                    <Button color="primary" onClick={toggleModalOrder}>
                                        <i className="fa fa-plus-circle"></i> Tambah Reservasi Offline
                                    </Button>
                                    <Button color="success" onClick={handleClickExport}>
                                        <i className="fa fa-download"></i> Ekspor
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </div>
                </div>
            </Col>
        </Fragment>
    );
};

export default FindOrder;